import React, { useState } from "react";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-solid.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { FontStyles } from "../utils/font-styles.ts";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { cn } from "../utils/cn.ts";
import { focusStylesOutline } from "../utils/focus-styles.ts";

export interface FAQsProps {
  faqList: FAQ[];
}

interface FAQ {
  question: string;
  answer: string;
}

export const FAQs: React.FC<FAQsProps> = (props) => {
  const [openedItem, setOpenedItem] = useState(-1);

  return (
    <div className={`flex flex-col gap-6.5`}>
      {/* Schema.org FAQ structured data for SEO; avoids XSS*/}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: props.faqList.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          })
            .replace(/</g, "\\u003c")
            .replace(/>/g, "\\u003e"),
        }}
      ></script>
      <div className={"flex flex-col gap-3 md:gap-3.5"}>
        <h2 className={`${FontStyles.h2} text-north-sea font-semibold`}>Frequently asked questions</h2>
        <p className={`${FontStyles.h6} !leading-normal text-slate`}>
          Find answers to common questions about our property valuation service.
        </p>
      </div>
      <div>
        {props.faqList.map((faq, index) => (
          <CollapsiblePrimitive.Root
            key={index}
            className={"py-4.5 flex flex-col gap-4.5 border-b border-foggy-firth"}
            open={index == openedItem}
            onOpenChange={() => {
              setOpenedItem(openedItem === index ? -1 : index);
            }}
          >
            <CollapsiblePrimitive.CollapsibleTrigger className={cn("flex w-full", focusStylesOutline)}>
              <div className={`flex justify-between w-full text-loch gap-2.5 md:gap-5`}>
                <p className={`text-left font-medium lg:leading-none ${FontStyles.h6}`}>{faq.question}</p>
                <i
                  className={`!flex text-body-xl items-center fa-solid fa-sharp ${openedItem == index ? "fa-angle-up" : "fa-angle-down"}`}
                />
              </div>
            </CollapsiblePrimitive.CollapsibleTrigger>
            <CollapsiblePrimitive.CollapsibleContent>
              <div className={`text-slate p-3.5 md:p-4.5 bg-cloud ${FontStyles["body-l"]} whitespace-pre-wrap`}>
                {faq.answer}
              </div>
            </CollapsiblePrimitive.CollapsibleContent>
          </CollapsiblePrimitive.Root>
        ))}
      </div>
    </div>
  );
};
